import { CustodyIntStatus } from "../../Custody/types";


export function getEnabledStatus(custody) {
  let allInternalStatus = Object.values(CustodyIntStatus);
  let skipItems = [];

  if (custody.internalstatus == CustodyIntStatus.CustodianRequest) {
   skipItems = [CustodyIntStatus.ClientRequest];
  }
  else if (custody.internalstatus != CustodyIntStatus.ClientRequest ) {
    skipItems = [
      CustodyIntStatus.ClientRequest, 
      CustodyIntStatus.CustodianRequest
    ];
  }
 
  if (custody.internalstatus == CustodyIntStatus.Returned) {
    skipItems = [...skipItems, CustodyIntStatus.ReturnRequested];
  }

  allInternalStatus = allInternalStatus.filter(
    s => skipItems.includes(s) == false
  );

  return allInternalStatus;
}